import {BaseContainerModel} from '../../base-container.model';
import {Bl_inv_stock_take_session_ext_RowClass} from '../../../dbschema/bl_inv_stock_take_session_ext.model';

export class StockTakeSessionExtensionModel extends BaseContainerModel {
  ext: Bl_inv_stock_take_session_ext_RowClass = new Bl_inv_stock_take_session_ext_RowClass();
}
